:host {
  display: inline-block;
  vertical-align: middle;
}

:host(:focus-visible) {
  outline: 1px solid $color-black;
}

.ux-icon {
  &__inner {
    display: block;
    height: 1em;
    width: 1em;
  }

  &__slot {
    display: none;
  }

  &__svg {
    display: block;
    height: 100%;
    width: 100%;
  }
}
